export function getUniqueNotEmptyElements(entities) {
    return entities.filter((el, index, arr) => arr.indexOf(el) === index).filter(e => e);
}
//# sourceMappingURL=getUniqueNotEmptyElements.js.map